import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  FaArrowLeft, 
  FaSpinner, 
  FaUser, 
  FaEnvelope, 
  FaPhone,
  FaClock
} from 'react-icons/fa';
import api from '../../services/api';
import './ContactDetail.css';

function ContactDetail() {
  const { id } = useParams();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchContact();
  }, [id]);

  const fetchContact = async () => {
    try {
      const response = await api.get(`/api/admin/contacts/${id}`);
      setContact(response.data);
    } catch (error) {
      console.error('Error fetching contact:', error);
      setError('Failed to load contact details');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="contact-detail-loading">
        <FaSpinner className="spinner" />
        <p>Loading contact details...</p>
      </div>
    );
  }

  if (error || !contact) {
    return (
      <div className="contact-detail-error">
        <p>{error || 'Contact not found'}</p>
        <Link to="/admin/dashboard/contacts" className="back-btn">
          <FaArrowLeft /> Back to Contacts
        </Link>
      </div>
    );
  }

  return (
    <div className="contact-detail-page">
      <div className="contact-detail-header">
        <Link to="/admin/dashboard/contacts" className="back-link">
          <FaArrowLeft /> Back to Contacts
        </Link>
        <h2>Contact Message Details</h2>
        <span className="contact-date">
          <FaClock /> Received: {formatDate(contact.createdAt)}
        </span>
      </div>

      <div className="contact-detail-content">
        {/* Contact Information Card */}
        <div className="contact-info-card">
          <div className="contact-avatar-large">
            {contact.name.charAt(0).toUpperCase()}
          </div>
          <h3>{contact.name}</h3>
          <div className="contact-info-items">
            <a href={`mailto:${contact.email}`} className="contact-info-item">
              <FaEnvelope />
              <span>{contact.email}</span>
            </a>
            <a href={`tel:${contact.phone}`} className="contact-info-item">
              <FaPhone />
              <span>{contact.phone}</span>
            </a>
          </div>
        </div>

        {/* Message Card */}
        <div className="message-card">
          <div className="message-subject">
            <h3>Subject</h3>
            <p>{contact.subject}</p>
          </div>

          <div className="message-body">
            <h3>Message</h3>
            <div className="message-text">
              {contact.message}
            </div>
          </div>

          {/* Quick Actions */}
          <div className="quick-actions">
            <a 
              href={`mailto:${contact.email}?subject=Re: ${contact.subject}`}
              className="action-btn primary"
            >
              <FaEnvelope /> Reply via Email
            </a>
            <a 
              href={`tel:${contact.phone}`}
              className="action-btn secondary"
            >
              <FaPhone /> Call Customer
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDetail;

